export default __webpack_public_path__ + "static/media/rahulthopate.ad811df0.jpeg";